<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-form
          ref="form"
          :model="form"
          size="small"
        >
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item
                label="Customer"
              >
                <AccountAutoComplete
                  ref="accountAutoComplete"
                  v-model="account"
                  @loadCarrier="loadCarrier"
                />
                <el-checkbox
                  v-model="form.showChildrenAccts"
                  label="Include Child Accounts"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                class="float-right"
                @click.native="downloadCSV()"
              >
                Export
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Item Export"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import AccountAutoComplete from '@/components/Application/Reports/AccountAutoComplete'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    AccountAutoComplete,
    Preview
  },
  data () {
    return {
      pageTitle: 'Items',
      breadcrumb: {
        name: 'Items',
        route: { name: 'reports-account-items' }
      },
      account: {},
      form: {
        accountId: null,
        showChildrenAccts: false
      },
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    loadCarrier () {
      this.form.accountId = this.$refs.accountAutoComplete.getAccountIds()
    },
    downloadCSV () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.configuration = {
            report: 'Items',
            params: this.form
          }
          this.isShowPreview = true
        }
      })
    }
  }
}
</script>
